[
  {
    "code": "LK-52",
    "name": "Ampara"
  },
  {
    "code": "LK-71",
    "name": "Anuradhapura"
  },
  {
    "code": "LK-81",
    "name": "Badulla"
  },
  {
    "code": "LK-51",
    "name": "Batticaloa"
  },
  {
    "code": "LK-11",
    "name": "Colombo"
  },
  {
    "code": "LK-31",
    "name": "Galle"
  },
  {
    "code": "LK-12",
    "name": "Gampaha"
  },
  {
    "code": "LK-33",
    "name": "Hambantota"
  },
  {
    "code": "LK-41",
    "name": "Jaffna"
  },
  {
    "code": "LK-13",
    "name": "Kalutara"
  },
  {
    "code": "LK-21",
    "name": "Kandy"
  },
  {
    "code": "LK-92",
    "name": "Kegalla"
  },
  {
    "code": "LK-42",
    "name": "Kilinochchi"
  },
  {
    "code": "LK-61",
    "name": "Kurunegala"
  },
  {
    "code": "LK-43",
    "name": "Mannar"
  },
  {
    "code": "LK-22",
    "name": "Matale"
  },
  {
    "code": "LK-32",
    "name": "Matara"
  },
  {
    "code": "LK-82",
    "name": "Monaragala"
  },
  {
    "code": "LK-45",
    "name": "Mullaittivu"
  },
  {
    "code": "LK-23",
    "name": "Nuwara"
  },
  {
    "code": "LK-72",
    "name": "Polonnaruwa"
  },
  {
    "code": "LK-62",
    "name": "Puttalam"
  },
  {
    "code": "LK-91",
    "name": "Ratnapura"
  },
  {
    "code": "LK-53",
    "name": "Trincomalee"
  },
  {
    "code": "LK-44",
    "name": "Vavuniya"
  }
]